import { BoxPosition_t, LabelSide, MultiPickType } from "blackbox";
import { Rect } from "../../layout_utils";

export interface ModelRect extends Rect {
	selected?: boolean;
	rotated?: boolean;
	multipick?: MultiPickType;
	multipickAlongWidth?: boolean;
  spin: BoxPosition_t['spin'];
  labelSide: LabelSide;
}

export enum SelectMode {
	Single,
	Multi,
}

export interface MultiPickData {
	multipick: MultiPickType;
	alongWidth: boolean;
}

type Coordinates = {
  x: number,
  y: number
}

export type LayoutBounds = {
  min: Coordinates;
  max: Coordinates;
}